import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PBXService } from 'src/app/services/pbx.service';
import { IPbxUser } from 'voxloud-types/dist/models';

@Component({
  selector: 'app-filter-users',
  templateUrl: './filter-users.component.html',
  styleUrls: ['./filter-users.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterUsersComponent),
      multi: true,
    },
  ],
})
export class FilterUsersComponent implements ControlValueAccessor {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: any = () => {};

  public users: IPbxUser[] = [];
  public selectedUser: IPbxUser;

  constructor(private pbxService: PBXService) {}

  public ngOnInit() {
    this.users = this.pbxService.getCachedUsers();
  }

  public changeUser(user: IPbxUser) {
    this.selectedUser = user;
    this.onChange(this.selectedUser);
  }

  writeValue(obj: string): void {
    if (obj) {
      this.selectedUser = this.users.find((user) => user.aggregate_id === obj);
      this.onChange(this.selectedUser);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
